import { Group } from '@mantine/core';
import { IconFilter, IconInbox, IconListCheck, IconMessageCircle } from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import ActionIconWithText from './ActionIconWithText';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
  addHandler: () => void;
}

const EventsPageFooter: FC<HandlersProps> = ({ filter, addHandler }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Aufgaben" onClick={() => navigate('/tasks')} useDefaultWidth>
        <IconListCheck />
      </ActionIconWithText>
      <NavAddIcon onClick={addHandler} />
      <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
        <IconInbox />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default EventsPageFooter;
